// src/meetInit.js
import { meet } from "@googleworkspace/meet-addons/meet.addons";

import { setMeetingCode } from "../store/GetMeetingCodeSlice";
const CLOUD_PROJECT_NUMBER = "530303062762";

// ✅ Keep one global session and promise (singleton)
let meetSessionPromise = null;



/**
 * Initialize the Meet Add-on once.
 * Returns an object: { session, sidePanelClient, context }
 */
export async function initMeetAddon(dispatch) {
  if (meetSessionPromise) return meetSessionPromise;
  meetSessionPromise = (async () => {
    console.log("[Meet Add-on] Initializing...");

    // 1️⃣ Create the Add-on session
    const session = await meet.addon.createAddonSession({
      cloudProjectNumber: CLOUD_PROJECT_NUMBER,
    });
    

    // 2️⃣ Create the side panel client
    const sidePanelClient = await session.createSidePanelClient();
    

    // 3️⃣ Get context via side panel client
    const meetingInfo = await sidePanelClient.getMeetingInfo();
    if(meetingInfo){
      if(meetingInfo.meetingCode){
        localStorage.setItem("meetingCode", meetingInfo.meetingCode);
        dispatch(setMeetingCode(meetingInfo.meetingCode) );
      }
    }
    return { session, sidePanelClient, meetingInfo };
  })();

  return meetSessionPromise;
}
